var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBusinessPermission || _vm.userType == "super_admin"
    ? _c("div", { staticClass: "setting-main-container" }, [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "profile.rescheduling_restructuring.detail_rescheduling_restructuring"
                  )
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 mb-4" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.rescheduling_restructuring.rescheduling_restructuring"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.rescheduling_restructuring != null
                ? _c("p", [
                    _vm._v(_vm._s(_vm.business.rescheduling_restructuring)),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }